import React, { useState } from 'react'
import AcceptIcon from 'assets/images/loans/accepted.svg'
import UpIcon from 'assets/images/rectangle/up1.svg'
import DownIcon from 'assets/images/rectangle/down1.svg'
import moment from 'jalali-moment'
import DetailAcceeptedLoan from './detail'
interface IItemProps {
    item: IAcceptedDemand
}
export default function Item({ item }: IItemProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    return (
        <div
            onClick={() => setIsOpen(!isOpen)}
            className=" px-2 py-2 rounded-lg  mx-3 bg-white shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)] my-3"
        >
            <div className="flex justify-between items-center">
                <div className=" items-center text-center flex flex-col justify-items-center w-1/2 ">
                    <img src={AcceptIcon} alt="accept" className=" w-[40%] " />
                    <p className=" text-sm text-green-1">اعطا شد</p>
                </div>
                <div className=" items-center text-center flex flex-col justify-items-center w-full">
                    <p className=" text-sm">
                        {item.loan_cashout_amount &&
                            item.loan_cashout_amount.toLocaleString()}{' '}
                        تومان
                    </p>
                    <p className=" text-sm">
                        به {item.poolship && item.poolship.name}
                    </p>
                </div>
                <div className=" text-sm text-right flex flex-col justify-items-center  w-2/3 border-r-2 border-dashed border-green-1">
                    <div className=" w-full flex justify-between">
                        <p className=" px-2">{item.num_repayments} قسط</p>
                        <img src={isOpen ? UpIcon : DownIcon} alt="rectangle" />
                    </div>
                    <p className=" px-2">
                        {moment
                            .from(item.acceptance_datetime, 'YYYY-MM-DD')
                            .locale('fa')
                            .format('YYYY/MM/DD')}
                    </p>
                </div>
            </div>
            {isOpen && <DetailAcceeptedLoan item={item} />}
        </div>
    )
}
